import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-6">
              <span className="text-2xl font-heading font-bold">MURRAY</span>
              <span className="text-2xl font-heading font-light text-accent ml-2">REALTOR</span>
            </div>
            <p className="text-sm text-primary-foreground/80 leading-relaxed">
              Your trusted partner in Greater Toronto Area real estate. Providing exceptional service and expertise for over 15 years.
            </p>
          </div>

          <div>
            <h3 className="text-sm uppercase tracking-widest font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/properties" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-properties">Properties</Link></li>
              <li><Link to="/about" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/service-areas" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-service-areas">Service Areas</Link></li>
              <li><Link to="/faq" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-faq">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm uppercase tracking-widest font-semibold mb-6">Service Areas</h3>
            <ul className="space-y-3 text-sm text-primary-foreground/80">
              <li>Toronto</li>
              <li>Mississauga</li>
              <li>Markham</li>
              <li>Richmond Hill</li>
              <li>Vaughan</li>
              <li>Brampton</li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm uppercase tracking-widest font-semibold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Phone className="w-4 h-4 mr-3 mt-0.5 text-accent" />
                <a href="tel:4168278717" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-phone">
                  (416) 827-8717
                </a>
              </li>
              <li className="flex items-start">
                <Mail className="w-4 h-4 mr-3 mt-0.5 text-accent" />
                <a href="mailto:paul@murrayrealtor.com" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-email">
                  paul@murrayrealtor.com
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="w-4 h-4 mr-3 mt-0.5 text-accent" />
                <span className="text-sm text-primary-foreground/80">
                  Toronto, Ontario
                </span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-12 pt-8 text-center">
          <p className="text-sm text-primary-foreground/60">
            © {new Date().getFullYear()} Murray Realtor. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
